module.exports = __webpack_public_path__ + "img/IMG_1904.d3bff2ca.jpg";